import i18n from 'i18next';

/**
 * Equipe de Agentes — bundle i18n do módulo `/agentes` (WP-10).
 *
 * Registrado idempotentemente no boot (`App.tsx`), no molde de
 * `registerInboxTranslations()`. Só o que aparece em NAVEGAÇÃO e os avisos
 * cuja redação é contratual mora aqui; as telas usam
 * `t('chave', 'texto pt-BR')` com fallback embutido, que é o padrão do código
 * novo da casa (inbox / radar / autopilot).
 *
 * Uma string tem dono fora deste repositório e NÃO pode ser reescrita aqui:
 * `agentes.handoff.takeoverAction` espelha, byte a byte, a constante
 * `AUTOPILOT_REPLY_TAKEOVER_ACTION_LABEL` congelada em
 * janus-tenant-management (`app/services/notification_kinds.py:132`, com
 * teste em `tests/test_agent_messaging_kinds.py:125`). O vendedor precisa
 * reconhecer na tela o MESMO rótulo que recebeu na notificação; duas
 * redações para o mesmo ato são duas ações diferentes aos olhos dele.
 */

/** Cópia literal de `AUTOPILOT_REPLY_TAKEOVER_ACTION_LABEL` (tenant-mgmt). */
export const TAKEOVER_ACTION_LABEL = 'Assumir esta conversa';

const AGENTES_PT_BR = {
  sidebar: {
    agentes: 'Equipe de Agentes',
  },
  agentes: {
    title: 'Equipe de Agentes',
    subtitle: 'Contrate, configure e ensaie o agente antes de soltá-lo numa conversa real.',
    tabs: {
      hiring: 'Contratação',
      config: 'Configuração',
      knowledge: 'Base de conhecimento',
      rehearsal: 'Ensaio',
      seller: 'Meu painel',
    },
    handoff: {
      takeoverAction: TAKEOVER_ACTION_LABEL,
    },
  },
} as const;

const AGENTES_EN_US = {
  sidebar: {
    agentes: 'Agent Team',
  },
  agentes: {
    title: 'Agent Team',
    subtitle: 'Hire, configure and rehearse the agent before it joins a real conversation.',
    tabs: {
      hiring: 'Hiring',
      config: 'Configuration',
      knowledge: 'Knowledge base',
      rehearsal: 'Rehearsal',
      seller: 'My panel',
    },
    handoff: {
      // Deliberately NOT translated: the label must match the pt-BR push
      // notification the seller received, which tenant-management emits in
      // pt-BR only.
      takeoverAction: TAKEOVER_ACTION_LABEL,
    },
  },
} as const;

let registered = false;

export function registerAgentesTranslations(): void {
  if (registered) return;
  i18n.addResourceBundle('pt-BR', 'translation', AGENTES_PT_BR, true, true);
  i18n.addResourceBundle('en-US', 'translation', AGENTES_EN_US, true, true);
  registered = true;
}
